<div class="pl">
    <!-- The parent the admin is trying to add — their own input, echoed back -->
    <div class="pl-new" *ngIf="newParent">
        <span class="pl-new__label">{{ 'student-conflicts.adding' | translate }}</span>
        <span class="pl-new__name">{{ newParent.parent_name || '-' }}</span>
        <span class="pl-new__meta pl-ltr">{{ newParent.parent_national_id || '-' }}</span>
        <span class="pl-new__meta pl-ltr">{{ phone(newParent) }}</span>
    </div>

    <div class="pl__cards">
        <div class="pl-card" *ngFor="let p of parents; trackBy: trackByUserId" [class.pl-card--chosen]="isChosen(p)"
            [class.pl-card--blocked]="isBlockedByOther(p)">
            <div class="pl-card__head">
                <span class="pl-card__name">{{ p.parent_name || '-' }}</span>
                <span class="pl-badge" [class.pl-badge--other]="!p.in_school">
                    {{ (p.in_school ? 'student-conflicts.badge-in-school' : 'student-conflicts.badge-other-school') | translate }}
                </span>
                <span *ngIf="isUpdated(p)" class="pl-tag">{{ 'student-conflicts.updated' | translate }}</span>
            </div>

            <!-- In my school: the whole record -->
            <ng-container *ngIf="p.in_school">
                <div class="pl-row">
                    <span class="pl-row__label">{{ 'student-conflicts.fields.parent_national_id' | translate }}</span>
                    <span class="pl-row__value pl-ltr">{{ p.parent_national_id || '-' }}</span>
                </div>
                <div class="pl-row">
                    <span class="pl-row__label">{{ 'student-conflicts.fields.parent_phone_number' | translate }}</span>
                    <span class="pl-row__value pl-ltr">{{ phone(p) }}</span>
                </div>
                <div class="pl-row">
                    <span class="pl-row__label">{{ 'student-conflicts.fields.parent_email' | translate }}</span>
                    <span class="pl-row__value pl-ltr">{{ p.parent_email || '-' }}</span>
                </div>
                <p class="pl-card__note">
                    <ng-container *ngIf="p.children_in_school?.length">
                        {{ 'student-conflicts.also-parent-of' | translate: { k: childNames(p) } }}
                    </ng-container>
                    <ng-container *ngIf="!p.children_in_school?.length">
                        {{ 'student-conflicts.no-other-children' | translate }}
                    </ng-container>
                </p>
            </ng-container>

            <!-- Another school: masked by the API, and only that is shown -->
            <ng-container *ngIf="!p.in_school">
                <div class="pl-row">
                    <span class="pl-row__label">{{ 'student-conflicts.fields.parent_national_id' | translate }}</span>
                    <span class="pl-row__value pl-ltr">{{ masked(p.parent_national_id_last4) }}</span>
                </div>
                <div class="pl-row">
                    <span class="pl-row__label">{{ 'student-conflicts.fields.parent_phone_number' | translate }}</span>
                    <span class="pl-row__value pl-ltr">{{ masked(p.parent_phone_last4) }}</span>
                </div>
                <div class="pl-row">
                    <span class="pl-row__label">{{ 'student-conflicts.fields.parent_email' | translate }}</span>
                    <span class="pl-row__value pl-row__value--muted">{{ 'student-conflicts.email-hidden' | translate }}</span>
                </div>
            </ng-container>

            <div class="pl-card__foot">
                <ng-container *ngIf="isChosen(p)">
                    <span class="pl-will">{{ 'student-conflicts.will-unlink' | translate }}</span>
                    <button type="button" class="pl-link" [disabled]="locked" (click)="undoChoice()">
                        {{ 'student-conflicts.undo' | translate }}
                    </button>
                </ng-container>
                <ng-container *ngIf="!isChosen(p)">
                    <button type="button" class="pl-unlink" [disabled]="locked || isBlockedByOther(p)"
                        (click)="askUnlink(p)">
                        {{ 'student-conflicts.unlink-parent' | translate }}
                    </button>
                    <span *ngIf="isBlockedByOther(p)" class="pl-card__why">
                        {{ 'student-conflicts.only-one' | translate }}
                    </span>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Destructive confirm, above the conflict dialog -->
<div *ngIf="confirming" class="pl-backdrop" (click)="keep()">
    <div class="pl-confirm" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
        <h4 class="pl-confirm__title">
            {{ 'student-conflicts.confirm-title' | translate: { p: confirming.parent_name } }}
        </h4>

        <ng-container *ngIf="confirming.in_school">
            <p>{{ 'student-conflicts.confirm-sees' | translate: { p: confirming.parent_name } }}</p>
            <p *ngIf="confirming.children_in_school?.length">
                {{ 'student-conflicts.confirm-stays' | translate: { p: confirming.parent_name, k: childNames(confirming) } }}
            </p>
            <p *ngIf="!confirming.children_in_school?.length">
                <strong>{{ 'student-conflicts.confirm-leaves' | translate: { p: confirming.parent_name } }}</strong>
            </p>
        </ng-container>

        <ng-container *ngIf="!confirming.in_school">
            <p>{{ 'student-conflicts.confirm-other-1' | translate }}</p>
            <p>{{ 'student-conflicts.confirm-other-2' | translate }}</p>
            <p>{{ 'student-conflicts.confirm-other-3' | translate }}</p>
            <label class="pl-check">
                <input type="checkbox" [checked]="confirmChecked"
                    (change)="confirmChecked = $any($event.target).checked">
                <span>{{ 'student-conflicts.confirm-check' | translate }}</span>
            </label>
        </ng-container>

        <div class="pl-confirm__actions">
            <button type="button" class="pl-btn" (click)="keep()">
                {{ 'student-conflicts.keep' | translate }}
            </button>
            <button type="button" class="pl-btn pl-btn--danger" [disabled]="!canConfirm" (click)="confirmUnlink()">
                {{ 'student-conflicts.confirm-unlink' | translate }}
            </button>
        </div>
    </div>
</div>
